const ProductCard = class {
  constructor(element, options) {
    this.$element = element
    this.$swatches = this.$element.querySelectorAll('.product-card__swatch')
    this.options = options

    const productJsonElement = this.$element.querySelector(
      '[data-product-json]',
    )
    if (productJsonElement) {
      const jsonData = JSON.parse(productJsonElement.innerHTML)
      this.productData = jsonData.product
      const selectedVariantId = jsonData.selected_variant_id
      for (const variant of this.productData.variants) {
        if (variant.id === selectedVariantId) {
          this.currentVariant = variant
          this.option1 = variant.option1
          this.option2 = variant.option2
          this.option3 = variant.option3
          break
        }
      }
    }
    this._attachListeners()
  }

  destroy() {
    this.element.off('click')
  }

  _attachListeners() {
    // this.delegateElement.on('change', '.product-form__single-selector', this._onOptionChanged.bind(this));
    // this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
    for (const swatch of this.$swatches) {
      swatch.addEventListener('click', this._handleSwatchClick.bind(this))
    }
  }

  _findVariant(id) {
    return this.productData.variants.find((variant) => variant.id === id)
  }

  _handleSwatchClick(evt) {
    this._handleVariantChange(evt.target.dataset.variantId)
  }

  _handleVariantChange(variantId) {
    const newVariant = this._findVariant(variantId)
    this._updateImages(newVariant)
  }

  _updateImages(variant) {
    const $images = this.$element.querySelectorAll('.product-card__image')

    if (!$images) return

    const $imgEl = $images[0].querySelector('nova-adaptive-image')

    $imgEl.image = btoa(variant.featured_image.src)
  }

  _updatePrice(variant) {}
}

window.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('.product-card')

  for (const el of productCards) {
    new ProductCard(el)
  }
})
